export const nop = () => {
  return {
    type: 'NOP'
  }
}
